<template>
  <v-card class="mx-auto">
    <v-card-title>
      <h1 class="display-1">Error page</h1>
    </v-card-title>
    <v-card-text>
      Server Error
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
    </v-card-actions>
  </v-card>
</template>

<script>

export default {
  data: () => ({
  }),
  methods: {
  }
}
</script>
